import React from 'react';
import { PageProps, graphql } from 'gatsby';
import { IGatsbyImageData, GatsbyImage } from 'gatsby-plugin-image';
import { MDXRenderer } from 'gatsby-plugin-mdx';

import { SEO, ContactForm, Promotion, Icon, Container } from '@components';

import * as s from './styles.module.scss';

interface IServicePageQuery {
    mdx: {
        body: string;
        frontmatter: {
            title: string;
            description: string;
            featured: {
                alt: string;
                src: {
                    childImageSharp: {
                        gatsbyImageData: IGatsbyImageData;
                    };
                };
            };
            brands: ReadonlyArray<{
                name: string;
                type: string;
                url: string;
                src: {
                    childImageSharp: {
                        gatsbyImageData: IGatsbyImageData;
                    };
                };
            }>;
        };
    };
}

function Service({ data }: PageProps<IServicePageQuery>) {
    return (
        <Container className={s.container}>
            <SEO title={data.mdx.frontmatter.title} />
            <div className={s.body}>
                <h1 className={s.title}>{data.mdx.frontmatter.title}</h1>
                <GatsbyImage
                    image={data.mdx.frontmatter.featured.src.childImageSharp.gatsbyImageData}
                    alt={data.mdx.frontmatter.featured.alt}
                />
                <div className={s.promotion}>
                    <Promotion
                        link="https://apply.svcfin.com/home/dealerAuthentication?id=815126916&key=1742219857"
                        linkName="Apply Now"
                        icon={<Icon name="finance" />}
                    >
                        Let your dream become reality. Enjoy deferred or no interest on your next project with a
                        qualified loan.
                    </Promotion>
                </div>
                <div className={s.mdx}>
                    <MDXRenderer>{data.mdx.body}</MDXRenderer>
                </div>
                {data.mdx.frontmatter.brands && (
                    <>
                        <h3 className={s.brandListTitle}>Manufacturers</h3>
                        <div className={s.brandList}>
                            {data.mdx.frontmatter.brands.map((brand) => (
                                <a className={s.brand} href={brand.url}>
                                    <GatsbyImage image={brand.src.childImageSharp.gatsbyImageData} alt={brand.name} />
                                    <p>{brand.type}</p>
                                </a>
                            ))}
                        </div>
                    </>
                )}
            </div>
            <div className={s.formContainer}>
                <ContactForm title="Request a Free Estimate" className={s.contactForm} />
            </div>
        </Container>
    );
}

export default Service;

export const pageQuery = graphql`
    query ServiceQuery($slug: String!) {
        mdx(slug: { eq: $slug }) {
            body
            frontmatter {
                title
                description
                featured {
                    alt
                    src {
                        childImageSharp {
                            gatsbyImageData(
                                aspectRatio: 2.5
                                layout: CONSTRAINED
                                width: 800
                                transformOptions: { cropFocus: CENTER }
                            )
                        }
                    }
                }
                brands {
                    name
                    type
                    url
                    src {
                        childImageSharp {
                            gatsbyImageData(
                                aspectRatio: 1
                                layout: CONSTRAINED
                                width: 150
                                transformOptions: { fit: CONTAIN }
                                backgroundColor: "#ffffff"
                            )
                        }
                    }
                }
            }
        }
    }
`;
